import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
import NewIqacSidebar from './NewIqacSidebar'

function InstitutionalDevelopmentPlan() {
  return (
    <>
    <style>{` .footer_main01  { display:none;      } `}</style>
      <div className='new_iqac'>
         
         <div className='row'>
             <div className='col-md-3'>
                    <NewIqacSidebar />
             </div>

             <div className='col-md-9'>
               <div className='home'>
                   <div className='about'>
                       <div className='row'>
                           <div className='col-md-12'>
                               <div className='text'>
                                   <h3>Institutional Development Plan
                                   </h3>
                                   <div className='imgs'>
                                    <img src='/assets/img/idpbanner.jpg'></img>
                                    </div>
                                    <br></br>
                                    <p>The Institutional Development Plan of MVN University serves as a strategic roadmap for fostering academic excellence, innovation, and holistic
growth. It outlines our long-term vision, goals, and actionable strategies to strengthen infrastructure, enhance teaching–learning quality, promote
impactful research, and expand community engagement. Guided by our commitment to quality, inclusivity, and equity, the IDP aligns institutional
priorities with national and global educational benchmarks. It emphasizes capacity building, digital transformation, sustainable practices, and
industry collaborations to prepare our students for the challenges of the future. Through this plan, MVN University reaffirms its dedication to
continuous improvement and societal contribution.
</p>
<p><a href="/assets/img/INSTITUTIONAL_DEVELOPMENT_PLAN_MVNU.pdf" target='_blank'>Institutional Development Plan (IDP)</a></p>
                               </div>
                           </div>
                       </div>
                   </div>
                 
               </div>
             </div>


         </div>

    

 </div>

    </>
  )
}

export default InstitutionalDevelopmentPlan